const Person = {
    elemName: '人物',
    type: 'inline',
    doc: '人名をマークアップします。',
    example: '｛大石内蔵助｝',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '{{$1}}',
    htmlTemplate: `<span {{{$htmlId}}} class="Person {{$classes}}">{{{$1}}}</span>`,
    xmlTemplate: `<persName {{{$xmlId}}} {{{$xmlSubtypes}}}>{{{$1}}}</persName>`,
    docxTemplate: `<w:r><w:rPr><w:rFonts w:hint="eastAsia"/></w:rPr><w:t>{{$text}}</w:t></w:r>`,
    latexTemplate: '{{$text}}'
};
export default Person;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGVyc29uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnZlcnRlci9pbmxpbmVfcnVsZXMvUGVyc29uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sTUFBTSxHQUFtQjtJQUM5QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxRQUFRO0lBQ2QsR0FBRyxFQUFFLGVBQWU7SUFDcEIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsWUFBWSxFQUFFLFFBQVE7SUFDdEIsWUFBWSxFQUFFLGlFQUFpRTtJQUMvRSxXQUFXLEVBQUUsK0RBQStEO0lBQzVFLFlBQVksRUFBRSw2RUFBNkU7SUFDM0YsYUFBYSxFQUFFLFdBQVc7Q0FDMUIsQ0FBQztBQUVGLGVBQWUsTUFBTSxDQUFDIn0=